import { list } from "sources/books/couplings";
import { namesList } from "sources/books/drivers";
import components from "./components";
import { config as driverConfig, initialState as driverInitialState } from "./driver";
import { config as trailerConfig, initialState as trailerInitialState } from "./trailer";
import { config as truckConfig, initialState as truckInitialState } from "./truck";

const rangeFilter = (firstPoint) => {
    if (!firstPoint || !firstPoint.planEnterDate) {
        return {};
    }
    return {
        startedAt: { le: new Date(firstPoint.planEnterDate) },
        endedAt: { ge: new Date(firstPoint.planEnterDate) },
    };
};

const configByName = {
    truck: (hasCouplingsAccess, firstPoint) => ({
        config: {
            carId: {
                ...truckConfig.carId,
                ...(hasCouplingsAccess
                    ? {
                          inputProps: { name: "coupling" },
                          filterPropName: "car/number",
                          propName: "car.number",
                          components: components.couplings,
                          dataKey: Number(new Date(firstPoint.planEnterDate)),
                          url: (props) => list(props, rangeFilter(firstPoint)),
                      }
                    : {}),
            },
        },
        initialState: truckInitialState,
    }),
    trailer: (hasCouplingsAccess, firstPoint) => ({
        config: {
            trailerId: {
                ...trailerConfig.trailerId,
                ...(hasCouplingsAccess
                    ? {
                          inputProps: { name: "coupling" },
                          filterPropName: "trailer/number",
                          propName: "trailer.number",
                          components: components.couplings,
                          dataKey: Number(new Date(firstPoint.planEnterDate)),
                          url: (props) => list(props, rangeFilter(firstPoint)),
                      }
                    : {}),
            },
        },
        initialState: trailerInitialState,
    }),
    driver: (hasCouplingsAccess, firstPoint) => ({
        config: {
            id: {
                ...driverConfig.id,
                ...(hasCouplingsAccess
                    ? {
                          inputProps: { name: "coupling" },
                          filterPropName: "driver/fullName",
                          propName: "driver.fullName",
                          components: components.couplings,
                          dataKey: Number(new Date(firstPoint.planEnterDate)),
                          url: (props) => list(props, rangeFilter(firstPoint)),
                      }
                    : {}),
            },
        },
        initialState: driverInitialState,
    }),
    secondaryDriver: () => ({
        config: {
            id: {
                // async-select
                label: "Второй водитель",
                inputProps: { name: "secondaryDriver" },
                url: namesList,
                filterPropName: "fullName",
                propName: "fullName",
                components: components.driver,
            },
        },
        initialState: driverInitialState,
    }),
};

export default configByName;
